import React, { useContext, useEffect, useRef } from "react";
import { Stack, Typography } from "@mui/material";
import { QuestionsContext } from "../../../../../provider/MyContexts";
import GenToolBar from "./GenToolBar";
import DetailWindow, { MIN_HEIGHT } from "./questionModal/DetailWindow";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import QuestionCard from "./overview/SortableQuestionCard";
import { InsertHoverArea } from "./InsertPlaceholder";
import { LoadingBox2 } from "../../../components/LoadingBox";

type Props = {
  activeStep: number;
  handleNext: () => void;
  handleBack: () => void;
  setShowPage: (page: string) => void;
};

export default function PageContents(props: Props) {
  const { activeStep, handleBack, handleNext, setShowPage } = props;

  const {
    questions,
    updateQuestions,
    selectedSheet,
    updateEditSheet,
    editSheet,
    addQuestion,
    autoSetBaseSheet,
    baseSheet,
    loadig,
  } = useContext(QuestionsContext);

  const [openEditor, setOpenEditor] = React.useState(false);

  const handleEditorSwitch = () => {
    if (openEditor) {
      if (windowHeight < MIN_HEIGHT) {
        unfoldDetailWindow();
      } else {
        handleEditorClose();
      }
    } else {
      handleEditorOpen();
    }
  };

  const handleEditorOpen = () => {
    setOpenEditor(true);
  };
  const handleEditorClose = () => {
    setOpenEditor(false);
  };

  const [windowHeight, setWindowHeight] = React.useState(0);

  function foldDetailWindow() {
    if (openEditor) {
      setWindowHeight(MIN_HEIGHT - 1);
    }
  }
  function unfoldDetailWindow() {
    setWindowHeight(600);
  }

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      const oldIndex = questions.findIndex((q) => q.questionId === active.id);
      const newIndex = questions.findIndex((q) => q.questionId === over.id);

      const newQuestions = arrayMove(questions, oldIndex, newIndex);

      updateQuestions(newQuestions);
    }
  };

  const itemRefs = useRef([]);
  useEffect(() => {
    itemRefs.current = questions.map((_, i) => itemRefs.current[i] || React.createRef());
  }, [questions]);

  const handleScrollTo = (index) => {
    if (itemRefs.current[index]?.current) {
      itemRefs.current[index].current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [hoverIndex, setHoverIndex] = React.useState<number | null>(null);

  useEffect(() => {
    if (selectedSheet) {
      updateEditSheet(selectedSheet);
      // autoSetBaseSheet();
    }
  }, [selectedSheet]);

  return (
    <Stack overflow={"auto"} height={"calc(100vh - 100px)"} marginX={-1}>
      <GenToolBar handleScrollTo={handleScrollTo} />
      {questions.length === 0 ? (
        loadig ? (
          <LoadingBox2 />
        ) : (
          <Stack width={"100%"} height={"100%"} alignItems={"center"} justifyContent={"center"}>
            <Typography
              variant="body_M"
              sx={{
                paddingX: 2,
              }}
            >
              {`${baseSheet == "form" ? "調査票" : "項目一覧"}シートから設問データが見つかりませんでした。`}
            </Typography>
          </Stack>
        )
      ) : (
        <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext
            items={questions.map((q) => q.questionId)}
            strategy={verticalListSortingStrategy}
          >
            <Stack
              flex={1}
              overflow={"auto"}
              padding={2}
              spacing={0.5}
              onClick={handleEditorClose}
              paddingBottom={3}
            >
              {selectedSheet &&
                questions.map((_, index) => {
                  return (
                    <React.Fragment key={questions[index].questionId}>
                      <InsertHoverArea
                        index={index}
                        isVisible={hoverIndex === index}
                        onInsert={() => {
                          addQuestion(index);
                        }}
                        onHover={() => setHoverIndex(index)}
                        onLeave={() => setHoverIndex(null)}
                      />
                      <QuestionCard
                        key={questions[index].questionId}
                        id={questions[index].questionId}
                        index={index}
                        handleOpenEditor={handleEditorSwitch}
                        targetRef={itemRefs.current[index]}
                      />
                      {index === questions.length - 1 && (
                        <InsertHoverArea
                          index={questions.length}
                          isVisible={hoverIndex === questions.length}
                          onInsert={() => {
                            addQuestion();
                          }}
                          onHover={() => setHoverIndex(questions.length)}
                          onLeave={() => setHoverIndex(null)}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
            </Stack>
          </SortableContext>
        </DndContext>
      )}
      <DetailWindow
        openEditor={openEditor}
        windowHeight={windowHeight}
        setWindowHeight={setWindowHeight}
        foldDetailWindow={foldDetailWindow}
        unfoldDetailWindow={unfoldDetailWindow}
      />
    </Stack>
  );
}
